<template>
  <Loadings v-if="statusLoading ===true"/>
  <section v-else v-for="(list , index) in lists">
    <div class="justify-content-center align-items-center d-flex">
      <div class="col-lg-4  col-md-4 col-sm-4 "></div>
      <div class="mypanel w-100 ">
        <div class="list-group">
          <h5 class="question">سوال {{ index + 1 }} </h5>
          <h6 class="title"><span style="color:red">*</span>{{ list.question }}</h6>
          <label class="list-group-item list2" :id='`question_first_${list.id}`'>
            <div class="justify-content-start">
              <span :id='`question_one${list.id}`'> <sapn class="ms-2">1_</sapn> </span>
              <input class="form-check-input me-1" type="radio" value="" name="question_first"
                     @click="Selections($event,list.id ,'question_one')">
              <span>{{ list.question_one }}</span>
            </div>
          </label>
          <label class="list-group-item list2" :id='`question_two_${list.id}`'>
            <span :id='`question_two${list.id}`'> <sapn class="ms-2">2_</sapn> </span>
            <input class="form-check-input me-1" type="radio" value="" name="question_two"
                   @click="Selections($event,list.id ,'question_two')">
            <span>{{ list.question_two }}</span>
          </label>
          <label class="list-group-item list2" :id='`question_three_${list.id}`'>
            <span :id='`question_three${list.id}`'> <sapn class="ms-2">3_</sapn> </span>
            <input class="form-check-input me-1" type="radio" value="" name="question_three"
                   @click="Selections($event,list.id ,'question_three')">
            <span>{{ list.question_three }}</span>
          </label>
          <label class="list-group-item list2" :id='`question_four_${list.id}`'>
            <span :id='`question_four${list.id}`'> <sapn class="ms-2">4_</sapn> </span>
            <input class="form-check-input me-1" type="radio" value="" name="question_four"
                   @click="Selections($event,list.id,'question_four')">
            <span>{{ list.question_four }}</span>
          </label>
        </div>
      </div>

      <div class="col-lg-2 col-md-2 col-sm-1"></div>
    </div>
  </section>

  <section class="d-flex col-lg-2 fixed-circle-counter" style="text-align: center;" id="fixedCircleCounter">
    <div class="d-flex flex-column justify-center card" id="myCircleCounter" style=" border-radius: 10px 20px;">
      <div class="p-2">تعداد سوالات ها: <span style="color: red;  font-size: 15px">{{ (count_a) ? count_a : 0 }}</span>
      </div>
      <div class="p-2" v-if="loading"> پاسخ داده شده:
        <span class="spinner-grow spinner-grow-sm" style="color: rgba(211,7,7,0.79) !important;" role="status" aria-hidden="true"></span>
        <span class="sr-only">Loading...</span>
      </div>

      <div class="p-2" v-else> پاسخ داده شده: <span style="color: red; font-size: 15px" >{{ (count_q) ? count_q : 0 }}</span></div>
    </div>
  </section>
</template>
<script>
import axios from "axios";
import config from "../../../../config/config.json";
import {useRoute} from "vue-router";
import Loadings from "@/customer/components/Layouts/sub/loadings.vue";

export default {
  name: "index",
  components: {
    Loadings
  },
  data() {
    return {
      b: 1,
      lists: "",
      statusLoading: true,
      iconStatus: false,
      count_a: "",
      count_q: "",
      loading:false
    }
  },
  created() {
    this.getDesignQuestion()

  },
  methods: {
    SaveDataToLocalStorage(question_id, answers_id) {
      const data = {question_id: question_id, answers_id: answers_id}
      localStorage.setItem(`question_${question_id}`, JSON.stringify(data))
    },
    getDesignQuestion() {
      let self = this;
      let cat_id = localStorage.getItem('cat_id')
      axios.get(`/DesignQuestion/${cat_id}`)
          .then(function (response) {
            let res = response.data;
            if (res.status === 'true') {
              self.count_a = res.data.list.length;
              self.statusLoading = false;
              self.lists = res.data.list
            }
            self.clear_localStoreg();
          })
          .catch(function (errors) {
            self.statusLoading = false;
            if (errors.response.status === 404) {
              return self.$router.push({path: `/results/${errors.response.data.messages}/404`});
            }
          });
    },
    clear_localStoreg() {
      for (let [key, value] of Object.entries(localStorage)) {
        if (key.includes("question")) {
          localStorage.removeItem(key);
        }
      }
    },

    Selections(event, question_id, answers_id) {
      let self = this;
      self.loading = true;
      self.extracted()
      self.RemoveSelects(question_id);
      self.SaveDataToLocalStorage(question_id, answers_id)
      document.getElementById(`${event.target.name}_${question_id}`).classList.add("clickSelections");
      document.getElementById(answers_id + question_id).innerHTML = "<i class=\"fas fa-check-circle\" style=\"color: #67d585\"></i>";
      self.iconStatus = true;
    },
    RemoveSelects(question_id, answers_id) {
      self.iconStatus = false;
      document.getElementById('question_first_' + question_id).classList.remove('clickSelections');
      document.getElementById('question_two_' + question_id).classList.remove('clickSelections');
      document.getElementById('question_three_' + question_id).classList.remove('clickSelections');
      document.getElementById('question_four_' + question_id).classList.remove('clickSelections');
      document.getElementById("question_one" + question_id).innerHTML = "1.";
      document.getElementById("question_two" + question_id).innerHTML = "2.";
      document.getElementById("question_three" + question_id).innerHTML = "3.";
      document.getElementById("question_four" + question_id).innerHTML = "4.";
      window.scrollBy(0, 440);
    },
    extracted() {
      let self = this;
      let countNumbers = 1;
      for (let [key, value] of Object.entries(localStorage)) {
        if (key.includes("question")) {
          countNumbers += 1;
        }
      }
      if (countNumbers <= self.count_a) {
        self.count_q = countNumbers
      }
      setTimeout(() => {
        self.loading = false;
      }, 1000);
    }
  },
}
</script>

<style scoped>

</style>